import React, { useState } from 'react'
import { Info, ChevronDown, ChevronUp } from 'lucide-react'

/**
 * SyncInfoBanner
 *
 * Banner informativo reutilizável para telas que possuem sincronização com o Varejo Online.
 * Exibe orientações sobre o processo de sincronização automática diária e o que fazer
 * quando um item não aparecer após a sincronização manual.
 *
 * Props:
 *   itemLabel  — label do item sincronizado (ex: "serviço", "vendedor"). Default: "serviço"
 *   steps      — array de strings com os passos personalizados. Se omitido, usa os passos padrão.
 */
export function SyncInfoBanner({ itemLabel = 'serviço', steps }) {
  const [expanded, setExpanded] = useState(false)

  const defaultSteps = [
    `Acesse a retaguarda do Varejo Online e verifique se o ${itemLabel} desejado está precificado.`,
    `Se o ${itemLabel} não estiver precificado, faça a precificação.`,
    'Volte para esta tela e clique em Sincronizar preço.',
    `Se o ${itemLabel} ainda não aparecer, abra um chamado enviando os seguintes prints:`,
  ]

  const defaultSubItems = [
    `${itemLabel.charAt(0).toUpperCase() + itemLabel.slice(1)} precificado na retaguarda`,
    `${itemLabel.charAt(0).toUpperCase() + itemLabel.slice(1)} não aparecendo aqui`,
  ]

  const stepsToRender = steps || defaultSteps

  return (
    <div className="flex flex-col border border-blue-200 rounded-lg bg-blue-50 px-4 py-3 mb-4 text-sm text-blue-900">
      <button
        type="button"
        className="flex items-center gap-2 w-full text-left"
        onClick={() => setExpanded(prev => !prev)}
      >
        <Info className="w-4 h-4 flex-shrink-0 text-blue-500" />
        <span className="font-medium flex-1">
          Os {itemLabel}s são sincronizados automaticamente todos os dias.
        </span>
        {expanded
          ? <ChevronUp className="w-4 h-4 text-blue-400" />
          : <ChevronDown className="w-4 h-4 text-blue-400" />
        }
      </button>

      {expanded && (
        <div className="mt-3 pl-6">
          <p className="mb-2 text-blue-800">
            Caso você procure um {itemLabel} e não o encontre aqui, siga o passo a passo abaixo:
          </p>
          <ol className="list-decimal list-outside pl-4 space-y-1 text-blue-800">
            {stepsToRender.map((step, i) => (
              <li key={i}>
                {step}
                {/* Subitens para o último passo padrão */}
                {!steps && i === stepsToRender.length - 1 && (
                  <ul className="list-disc list-outside pl-4 mt-1 space-y-0.5 text-blue-700">
                    {defaultSubItems.map((sub, j) => (
                      <li key={j}>{sub}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  )
}
